import { render, staticRenderFns } from "./UploadFileSidebar.vue?vue&type=template&id=368bff01&scoped=true"
import script from "./UploadFileSidebar.vue?vue&type=script&lang=js"
export * from "./UploadFileSidebar.vue?vue&type=script&lang=js"
import style0 from "./UploadFileSidebar.vue?vue&type=style&index=0&id=368bff01&prod&lang=scss&scoped=true"
import style1 from "./UploadFileSidebar.vue?vue&type=style&index=1&id=368bff01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368bff01",
  null
  
)

export default component.exports